module.exports = __webpack_public_path__ + "static/media/Drawphone.4c8aee89.png";